<template>
    <div class="client-info-table">
        <div class="title-container">
            <span class="sub-title">客户信息</span>
            <i :class="contentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapse"></i>
        </div>
        <div v-show="contentVisible">
            <el-table v-loading="loading" :data="tableData" border style="width: 100%" max-height="400px">
                <el-table-column show-overflow-tooltip prop="customerName" label="客户名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="customerCode" label="客户编码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="isRelation" label="是否有关联"></el-table-column>
                <el-table-column show-overflow-tooltip prop="customerType_" label="类型"></el-table-column>
                <el-table-column show-overflow-tooltip prop="customerPercent" label="占比(投资关系)"></el-table-column>
            </el-table>
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"></el-pagination>
        </div>
    </div>
</template>
<script>
import { queryCustomerList } from '../../../../../../api/cooperationCustomer'
import { dictWithUrl } from '@/components/lots/api'

export default {
    props: {
        supplierCode: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            loading: false,
            contentVisible: true,
            tableData: [],
            pageNo: 1,
            pageSize: 10,
            total: 0,
            dict: {},
        }
    },
    methods: {
        handleCurrentChange(v) {
            this.pageNo = v
            this.getList()
        },
        handleSizeChange(v) {
            this.pageSize = v
            this.pageNo = 1
            this.getList()
        },
        handleCollapse() {
            this.contentVisible = !this.contentVisible
        },
        getList() {
            this.loading = true
            queryCustomerList({
                supplierCode: this.supplierCode,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.total = res.data.totalCount || 0
                        this.tableData = (res.data.list || []).map(v => {
                            return {
                                ...v,
                                customerType_: v.customerType ? (v.customerType.split(',').map(c => this.dict['SRM_SUPPLIER_DRAINAGE_CUSTOMER'][c]) + '') : '',
                            }
                        })
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
    mounted() {
        dictWithUrl('SRM_SUPPLIER_DRAINAGE_CUSTOMER').then(res => {
            this.dict = res.data
            this.getList()
        })
    },
}
</script>
<style lang="less" scoped>
.client-info-table {
    .title-container {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 10px;

        i {
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }
    .sub-title {
        display: inline-block;
        font-weight: bold;
        font-size: 14px;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }
    .pagination {
        text-align: right;
        margin-top: 10px;
    }
}
</style>
